"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeaderDesktop = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _queryString = _interopRequireDefault(require("query-string"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _MenuOpen = _interopRequireDefault(require("@material-ui/icons/MenuOpen"));

var _userUtils = require("./userUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _searchWrapper;

  return {
    toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      alignItems: 'center'
    },
    logo: {
      padding: 0
    },
    searchWrapper: (_searchWrapper = {
      height: 36,
      display: 'flex',
      backgroundColor: 'white',
      border: '1px solid',
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderRadius: 4,
      width: 931
    }, _defineProperty(_searchWrapper, theme.breakpoints.up(1300), {
      marginLeft: -40
    }), _defineProperty(_searchWrapper, theme.breakpoints.down(1300), {
      width: '60.244%'
    }), _searchWrapper),
    searchIcon: {
      color: 'black',
      verticalAlign: 'middle'
    },
    primaryText: {
      marginTop: 2,
      color: theme.palette.text.primary,
      width: 200
    },
    secondaryText: {
      color: theme.palette.text.secondary,
      fontSize: 14
    },
    avatar: {
      padding: 0
    },
    menu: {
      marginTop: 48
    },
    menuAvatar: {
      marginRight: 16
    },
    menuIcons: _defineProperty({
      marginRight: 24,
      marginLeft: 8
    }, theme.breakpoints.down(1300), {
      marginRight: 0
    }),
    menuItemText: {
      color: theme.palette.text.primary,
      width: 'auto',
      fontSize: 14
    },
    inputLeftButton: {
      minWidth: 24,
      margin: 8,
      marginLeft: 16
    },
    inputRightButton: {
      width: 24,
      minWidth: 24,
      margin: '0 8px'
    },
    inputBaseRoot: {
      height: 24,
      padding: '6px 0'
    },
    menuStyle: {},
    centralized: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    appBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexDirection: 'row'
    },
    sandwichWrapper: {
      margin: '16px 24px 16px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      width: '32px',
      height: '32px',
      '& svg': {
        width: 32,
        height: 32
      }
    },
    toolbarSandwich: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      alignItems: 'center',
      flex: 1,
      padding: 0,
      paddingRight: 24
    },
    drawer: {
      backgroundColor: 'transparent',
      '& .MuiDrawer-paper': {
        width: 302,
        marginTop: 64,
        display: 'flex',
        alignItems: 'center'
      }
    }
  };
});

var HeaderDesktop = function HeaderDesktop(_ref) {
  var username = _ref.username,
      email = _ref.email,
      onClickHome = _ref.onClickHome,
      searchPlaceHolder = _ref.searchPlaceHolder,
      inputWrapperClasses = _ref.inputWrapperClasses,
      searchCallback = _ref.searchCallback,
      hiddenMenu = _ref.hiddenMenu,
      menuItems = _ref.menuItems,
      logo = _ref.logo,
      logoImg = _ref.logoImg,
      centralized = _ref.centralized,
      sandwich = _ref.sandwich,
      sandwichClosedIcon = _ref.sandwichClosedIcon,
      sandwichOpenedIcon = _ref.sandwichOpenedIcon,
      isOpenSandwich = _ref.isOpenSandwich,
      setIsOpenSandwich = _ref.setIsOpenSandwich;
  var classes = useStyles();
  var initials = (0, _userUtils.getInitials)(username);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var open = Boolean(anchorEl);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isTyping = _useState4[0],
      setIsTyping = _useState4[1];

  var searchTerm = '';

  if (window.location.search && window.location.search.includes('?query=')) {
    searchTerm = _queryString.default.parse(window.location.search).query;
  }

  var _useState5 = (0, _react.useState)(searchTerm),
      _useState6 = _slicedToArray(_useState5, 2),
      inputValue = _useState6[0],
      setInputValue = _useState6[1];

  var handleMenu = function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  function clearSearch() {
    setIsTyping(false);
    setInputValue('');
  }

  function handleSearchChange(evt) {
    setInputValue(evt.target.value);

    if (evt.target.value === '') {
      setIsTyping(false);
      return;
    }

    if (!isTyping) {
      setIsTyping(true);
    }
  }

  function handleSubmit(evt) {
    evt.preventDefault();
    searchCallback(inputValue);
  }

  function renderMenuItem(item) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      onClick: item.onClick,
      key: item.label
    }, item.nodeIcon, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.menuItemText
    }, item.label));
  }

  function renderSearchBar() {
    var inputWrapperStyle = inputWrapperClasses ? "".concat(classes.searchWrapper, " ").concat(inputWrapperClasses().root) : centralized ? "".concat(classes.searchWrapper, " ").concat(classes.centralized) : classes.searchWrapper;

    var searchIcon = /*#__PURE__*/_react.default.createElement(_core.InputAdornment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.inputLeftButton
    }, /*#__PURE__*/_react.default.createElement(_icons.SearchSharp, {
      className: classes.searchIcon
    })));

    var closeButton = /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
      position: "start"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      onClick: clearSearch,
      className: classes.inputRightButton
    }, /*#__PURE__*/_react.default.createElement(_icons.Close, null)));

    return /*#__PURE__*/_react.default.createElement("form", {
      className: inputWrapperStyle,
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_core.Input, {
      disableUnderline: true,
      placeholder: searchPlaceHolder,
      fullWidth: true,
      onChange: handleSearchChange,
      value: inputValue,
      classes: {
        input: classes.inputBaseRoot
      },
      startAdornment: searchIcon,
      endAdornment: isTyping || inputValue !== '' ? closeButton : null
    }));
  }

  function AvatarLogout() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, menuItems.map(function (item) {
      return renderMenuItem(item);
    }));
  }

  function AvatarLogin() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      className: classes.menuStyle
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: classes.menuAvatar
    }, initials), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.primaryText
    }, (0, _userUtils.listUser)(username, 24), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.secondaryText
    }, (0, _userUtils.listUser)(email, 28)))), menuItems.map(function (item) {
      return renderMenuItem(item);
    }));
  }

  function renderMenu() {
    return /*#__PURE__*/_react.default.createElement(_core.Menu, {
      className: classes.menu,
      anchorEl: anchorEl,
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      open: open,
      onClose: handleClose
    }, initials === null ? /*#__PURE__*/_react.default.createElement(AvatarLogout, null) : /*#__PURE__*/_react.default.createElement(AvatarLogin, null));
  }

  function renderAvatar() {
    if (hiddenMenu) {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: 40,
          height: 40
        }
      });
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      "aria-label": "Perfil do Usu\xE1rio",
      className: classes.avatar,
      onClick: handleMenu
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, null, initials)), renderMenu());
  }

  var handleClickHome = function handleClickHome(evt) {
    setInputValue('');
    setIsTyping(false);
    onClickHome(evt);
  };

  var sandwichMenu = function sandwichMenu() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      onClick: function onClick() {
        return setIsOpenSandwich(!isOpenSandwich);
      },
      onKeyDown: function onKeyDown() {
        return setIsOpenSandwich(!isOpenSandwich);
      },
      className: classes.sandwichWrapper,
      role: "button",
      tabIndex: 0,
      "aria-label": isOpenSandwich ? 'Fechar Menu' : 'Abrir Menu'
    }, isOpenSandwich ? sandwichOpenedIcon : sandwichClosedIcon));
  };

  if (sandwich) {
    return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
      className: classes.appBar
    }, sandwichMenu(), /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
      classes: {
        root: classes.toolbarSandwich
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: classes.logo,
      onClick: handleClickHome
    }, logo && /*#__PURE__*/_react.default.createElement("img", {
      style: {
        maxHeight: 40
      },
      src: logo,
      alt: "logo"
    }), logoImg && logoImg), renderSearchBar(), renderAvatar()));
  }

  return /*#__PURE__*/_react.default.createElement(_core.AppBar, null, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    classes: {
      root: classes.toolbar
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.logo,
    onClick: handleClickHome
  }, logo && /*#__PURE__*/_react.default.createElement("img", {
    style: {
      maxHeight: 40
    },
    src: logo,
    alt: "logo"
  }), logoImg && logoImg), renderSearchBar(), renderAvatar()));
};

exports.HeaderDesktop = HeaderDesktop;
HeaderDesktop.propTypes = {
  /**
   * Nome do usuário exibido ao clicar no menu
   */
  username: _propTypes.default.string,

  /**
   * Email do usuário exibido ao clicar no menu
   */
  email: _propTypes.default.string,

  /**
   * Função requerida para quando o usuário clicar no logotipo presente no header.
   */
  onClickHome: _propTypes.default.func.isRequired,

  /**
   * Mensagem que aparecerá como placeholder da barra de pesquisa
   */
  searchPlaceHolder: _propTypes.default.string,

  /**
   * Função requerida para quando a pessoa realizar a pesquisa (apertar o Enter).
   * Receberá como parâmetro o termo que está na barra de pesquisa
   */
  searchCallback: _propTypes.default.func.isRequired,

  /**
   *  Classes para serem aplicadas na `div` que engloba a barra de pesquisa
   */
  inputWrapperClasses: _propTypes.default.func,

  /**
   * Lista de objetos que serão concatenados ao menu (aberto ao clicar no avatar).
   */
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired).isRequired,
  hiddenMenu: _propTypes.default.bool,

  /**
   * Logo que aparecerá no topo da página.
   */
  logo: _propTypes.default.element,

  /**
   * Logo que aparecerá no topo da página caso seja passado uma tag de imagem.
   */
  logoImg: _propTypes.default.node,

  /**
   * Se 'TRUE' a search bar fica centralizada ao centro de forma absoluta
   */
  centralized: _propTypes.default.bool,

  /**
   * Se 'TRUE' habilita o menu sanduiche no header
   */
  sandwich: _propTypes.default.bool,

  /**
   * Ícone do menu sanduiche enquanto está fechado
   */
  sandwichClosedIcon: _propTypes.default.node,

  /**
   * Ícone do menu sanduiche enquanto está aberto
   */
  sandwichOpenedIcon: _propTypes.default.node,

  /**
   * Se 'TRUE', o estado do menu sandwich é aberto
   */
  isOpenSandwich: _propTypes.default.bool,

  /**
   * Funcao que manipula o estado do menu sanduiche
   */
  setIsOpenSandwich: _propTypes.default.func
};
HeaderDesktop.defaultProps = {
  email: 'email@somoseducacao.com.br',
  username: 'Saraiva Educacao',
  searchPlaceHolder: 'Buscar...',
  inputWrapperClasses: null,
  hiddenMenu: false,
  centralized: false,
  logo: null,
  logoImg: null,
  sandwich: false,
  sandwichClosedIcon: /*#__PURE__*/_react.default.createElement(_Menu.default, null),
  sandwichOpenedIcon: /*#__PURE__*/_react.default.createElement(_MenuOpen.default, null),
  isOpenSandwich: false,
  setIsOpenSandwich: null
};
var _default = HeaderDesktop;
exports.default = _default;